<template>
  <fieldset>
    <legend class="sr-only">
      {{ label }}
    </legend>
    <div class="row">
      <div class="column">
        <doe-label :name="`${name}.day`">
          Day
        </doe-label>
        <input
          :disabled="disabled || dynamicDisabledVal"
          autocomplete="off"
          type="text"
          :name="`${name}.day`"
          :id="`${name}.day`"
          v-model="day"
          class="max-w-xs mr-3"
          :class="{ hasError: errors.has(`${name}.day`) }"
          data-vv-as="Day"
          maxlength="2"
          :placeholder="placeholder"
          v-validate="'required|min:2|max:2|between:1,31'"
          :aria-describedby="generateAriaDescription(`${name}.day`)"
          @input="emitDate($event)"
        />
      </div>
      <div class="column">
        <doe-label :name="`${name}.month`">
          Month
        </doe-label>
        <input
          :disabled="disabled || dynamicDisabledVal"
          autocomplete="off"
          type="text"
          :name="`${name}.month`"
          :id="`${name}.month`"
          v-model="month"
          class="max-w-xs mr-3"
          :class="{ hasError: errors.has(`${name}.month`) }"
          data-vv-as="Month"
          maxlength="2"
          :placeholder="placeholder"
          v-validate="'required|min:2|max:2|between:1,12'"
          :aria-describedby="generateAriaDescription(`${name}.month`)"
          @input="emitDate($event)"
        />
      </div>
      <div class="column">
        <doe-label :name="`${name}.year`">
          Year
        </doe-label>
        <input
          :disabled="disabled || dynamicDisabledVal"
          autocomplete="off"
          type="text"
          :name="`${name}.year`"
          :id="`${name}.year`"
          v-model="year"
          class="max-w-sm"
          :class="{ hasError: errors.has(`${name}.year`) }"
          data-vv-as="Year"
          maxlength="4"
          :placeholder="placeholder"
          v-validate="`required|min:4|max:4|between:${fromYear},${toYear}`"
          :aria-describedby="generateAriaDescription(`${name}.year`)"
          @input="emitDate($event)"
        />
      </div>
      <input v-validate="'date_format:dd/MM/yyyy'" :data-vv-name="`${name}_date_field`"  :value="datevalue" :name="`${name}_date_field`" type="hidden">
    </div>
    <doe-error v-if="!errors.has(`${name}.day`) &&  !errors.has(`${name}.month`) && !errors.has(`${name}.year`) && errors.has(name+'_date_field')">
      {{ errors.first(`${name}_date_field`) ? `Date is invalid` : '' }}
    </doe-error>
    <doe-error v-if="errors.has(`${name}.day`)" :description="ariaErrorDescID(`${name}.year`)">
      {{ errors.first(`${name}.day`) }}
    </doe-error>
    <doe-error v-if="errors.has(`${name}.month`)" :description="ariaErrorDescID(`${name}.year`)">
      {{ errors.first(`${name}.month`) }}
    </doe-error>
    <doe-error v-if="errors.has(`${name}.year`)" :description="ariaErrorDescID(`${name}.year`)">
      {{ errors.first(`${name}.year`) }}
    </doe-error>
    <doe-hint :hint="hint" description="dateDescription" />
  </fieldset>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeDate",
  inject: {
    $validator: "$validator"
  },
  mixins: [dynamicValues],
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    validation: {
      type: [Object, String]
    },
    fromYear: {
      type: Number,
      default: 2010
    },
    toYear: {
      type: Number,
      default: 2019
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    },
    dynamicDisable: {
      type: [Boolean, Function],
      default: false
    },
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  data() {
    return {
      year: "",
      month: "",
      day: ""
    };
  },
  mounted() {
    if (typeof this.value !== "undefined" && this.value) {
      let d = new Date(this.value);
      this.year = d.getFullYear();
      this.month = this.zeroPad(d.getMonth() + 1, 2);
      this.day = this.zeroPad(d.getDate(), 2);
      this.emitDate()
    }
  },
  computed: {
    dynamicDisabledVal(){
      return this.getDisabledValue(this.dynamicDisable);
    },
    datevalue () {
      return `${this.day}/${this.month}/${this.year}`;
    }
  },
  methods: {
    zeroPad: (num, places) => String(num).padStart(places, '0'),
    generateAriaDescription(fieldName) {
      if (this.errors.has(fieldName)) {
        return this.ariaErrorDescID(fieldName);
      }
      if (this.hint) {
        // return this.ariaDescID(fieldName);
        return "dateDescription";
      }
      return false;
    },
    ariaDescID(fieldName) {
      return `${fieldName}Description`;
    },
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    },
    emitDate() {
      this.$nextTick(
        () => this.$validator.validate(this.name +'_date_field')
      )
      let dateString=`${this.day}-${this.month}-${this.year}`;
      var pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
      var regEx = new RegExp(pattern);
      if (dateString.match(regEx)) {
        let timestamp = new Date(this.year,this.month-1,this.day).getTime();
        this.$emit("input", timestamp);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div.row {
  @apply flex;
}
input {
  @apply bg-gray-300 border border-gray-800 rounded font-sans leading-snug px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
input.hasError {
  border-color: #d0021b;
}
input[type="text"]:disabled {
  @apply bg-gray-500;
  &:hover, &:focus {
    @apply border-gray-900;
    box-shadow: none;
  }
}
</style>
